import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const modulePasscode = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    campaignId: null,
    passcode: null,
    isCampaignValid: null,
    isPasscodeValid: null,
    paletteId: null,
    expirationDate: null,
    isCampaignExpired: null,
  }
};

export default modulePasscode;